import { z } from 'zod';

export const additionalUploadsPostResponseSchema = z.object({
  data: z.object({}),
  response: z.object({ date: z.string(), messages: z.array(z.string()), status: z.number(), type: z.string() }),
});
